import React from 'react';
import { BodyText, DataGrid, IFilteredDataGridColumnProps } from 'ui-toolkit';
import { IFeatureData } from '../../../types/administration/features/IFeature';
import { FeatureMenuDropdown } from './subComponents/FeatureMenuDropdown';

export interface IFeaturesTableProps {
  data: IFeatureData[];
  isFetching: boolean;
}

const columns: IFilteredDataGridColumnProps<IFeatureData>[] = [
  {
    dataField: 'name',
    headerStyle: { width: '120px' },
    text: 'Name',
  },
  {
    dataField: 'description',
    headerStyle: { width: '100px' },
    text: 'Description',
  },
  {
    dataField: 'isOn',
    headerStyle: { width: '100px' },
    formatter: (column, row) => {
      return <BodyText>{row.isOn ? 'Active' : 'Deactivated'}</BodyText>;
    },
    text: 'Is On',
  },
  {
    dataField: 'feature.menu',
    headerStyle: { width: '48px' },
    formatter: (column, row) => {
      return <FeatureMenuDropdown feature={row} />;
    },
    text: '',
  },
];

export const FeaturesTable: React.FC<IFeaturesTableProps> = ({ data, isFetching }) => {
  return <DataGrid columns={columns} data={data} keyField="name" loading={isFetching} remote />;
};
